// 统一的 API 错误类 / Unified API error classes.
// 将后端 {detail: {code, message, ...}} 信封映射到可区分的错误类型，
// 供 UI 层通过 instanceof 进行分支处理。
// Maps backend envelopes to distinct classes so the UI can branch via instanceof.

export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  constructor(status: number, code: string, message: string) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
  }
}

export class AuthError extends Error {
  constructor(message = "authentication required") {
    super(message);
    this.name = "AuthError";
  }
}

// 积分不足 / Insufficient credit — 402 INSUFFICIENT_CREDIT.
export class InsufficientCreditError extends Error {
  readonly cost: number;
  readonly current: number;
  constructor(cost: number, current: number, message = "credit insufficient") {
    super(message);
    this.name = "InsufficientCreditError";
    this.cost = cost;
    this.current = current;
  }
}

// 限流 / Rate limited — 429 RATE_LIMITED | RATE_LIMITED_HOURLY.
export class RateLimitedError extends Error {
  readonly retryAfterSeconds: number;
  readonly hourly: boolean;
  constructor(retryAfterSeconds: number, hourly: boolean, message = "rate limited") {
    super(message);
    this.name = "RateLimitedError";
    this.retryAfterSeconds = retryAfterSeconds;
    this.hourly = hourly;
  }
}

// 已有活跃仿真 / Active simulation exists — 409 ACTIVE_SIMULATION_EXISTS.
export class ActiveSimulationError extends Error {
  constructor(message = "active simulation exists") {
    super(message);
    this.name = "ActiveSimulationError";
  }
}

// 报告生成中 / Active report generation exists — 409 ACTIVE_REPORT_GENERATION_EXISTS.
export class ActiveReportGenerationError extends Error {
  constructor(message = "active report generation exists") {
    super(message);
    this.name = "ActiveReportGenerationError";
  }
}

// NOTE: VerifyRequiredError was removed in Stage E — see docs/superpowers/specs/…
